import {Vue} from 'vue-property-decorator';
import VeeValidate, {Validator} from 'vee-validate';
import * as ru from 'vee-validate/dist/locale/ru';

export const setupValidate = () => {
  Vue.use(VeeValidate, {locale: 'ru'});
  Validator.localize('ru', ru);
};
